import $ from 'jquery';

export default {
  init ({ target, label, click }) {

    $(click).on('click', ({ currentTarget }) => {
      this.$panel = $(currentTarget).parent().parent().find(target)
      this.$label = $(currentTarget).parent().parent().find(label)
      this.$expand = this.$label.find('.expand')
      this.toggle()
    })
  },
  toggle () {
    const isOpen = !(this.$panel.attr('data-is-open') === 'true')
    isOpen ? this.open() : this.close()
    this.$panel.attr('data-is-open', isOpen)
  },
  open () {
    this.$panel.parent().removeClass('closed')
    this.$panel.removeClass('closed')
    this.$label.removeClass('closed')
  },
  close () {
    this.$panel.parent().addClass('closed')
    this.$panel.addClass('closed')
    this.$label.addClass('closed')
  },
};
